/**
 * register-sw.ts — đăng ký service worker (public/sw.js) cho PWA.
 *
 * - Chỉ bản build (production): bản dev chạy HMR, service worker sẽ làm kẹt mã cũ.
 * - `VITE_DISABLE_SW=true` lúc build = công tắc tắt khẩn cấp: gỡ service worker đã cài + xoá kho lưu ở máy người dùng.
 * - Mọi lỗi đều bị nuốt: PWA chỉ là lớp bổ sung, không được làm hỏng việc mở ứng dụng.
 */
export function swEnabled(env: { PROD: boolean; VITE_DISABLE_SW?: string }): boolean {
  return env.PROD && env.VITE_DISABLE_SW !== 'true'
}

export async function disableServiceWorker(): Promise<void> {
  try {
    const regs = await navigator.serviceWorker.getRegistrations()
    await Promise.all(regs.map((r) => r.unregister()))
    const names = await caches.keys()
    await Promise.all(names.filter((n) => n.startsWith('ecdp-')).map((n) => caches.delete(n)))
  } catch { /* bỏ qua */ }
}

export function registerServiceWorker(): void {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return
  const env = import.meta.env
  if (env.PROD && env.VITE_DISABLE_SW === 'true') {
    window.addEventListener('load', () => { void disableServiceWorker() })
    return
  }
  if (!swEnabled(env)) return
  window.addEventListener('load', () => {
    // updateViaCache:'none' → luôn hỏi máy chủ bản sw.js mới, kể cả khi nginx đặt cache cho tệp tĩnh.
    navigator.serviceWorker.register('/sw.js', { scope: '/', updateViaCache: 'none' }).catch(() => { /* không hỗ trợ / bị chặn */ })
  })
}
